// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3FRDF","actionsCol":"EnrolledClinics_actionsCol__mHATl"};